import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../Context/UserContext";
import MyInput from "../../../Reusable/MyInput";
import Button from "../../../Reusable/Button";
import DivisionPageForm from "../../../masterFormPages/DivisionPageForm";
import toast from "react-hot-toast";
import { BaseURL } from "../../../Reusable/BaseURL";
import CreateRolePageForm from "./CreateRolePageForm";
import CreatedRoleViewPageForm from "./CreatedRoleViewPageForm";

export default function CreateRole() {
  const { darkTheme, loginData } = useContext(UserContext);
  const [divisionName, setDivisionName] = useState("");
  const [roleName, setRoleName] = useState("");
  const [isAdmin, setIsAdmin] = useState(0);
  const [poItemCheckBoxId, setPOItemCheckBoxId] = useState([]);
  const [addMoreToggle, setAddMoreToggle] = useState(false);
  const [allIndentItem, setAllIndentItem] = useState([]);
  // const [changingSelect, setChangingSelect] = useState(false);

  const [links, setLinks] = useState([]);
  const [firstPage, setFirstPage] = useState([]);
  const [totalNo, setTotalNo] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [getId, setGetId] = useState(0);
  const [spinner, setSpinner] = useState(true);

  const [submitAction, setSubmitAction] = useState("submit");

  // disabled action
  const [submitDisable, setSubmitDisable] = useState(false);
  const [updateDisable, setUpdateDisable] = useState(false);
  const [editDisable, setEditDisable] = useState(false);

  async function getAllIndentCreated() {
    const res = await fetch(`${BaseURL}/roles`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          setAllIndentItem(createRes.data.data);
          setSpinner(false);
        }
      });
  }

  // create Division
  async function createDivision(e) {
    e.preventDefault();
    // const formData = new FormData();
    // formData.append("name", divisionName);
    setSubmitDisable(true);
    const formData = {
      role_name: roleName,
      permissions: poItemCheckBoxId,
      is_admin: isAdmin,
    };

    const res = await fetch(`${BaseURL}/roles`, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        // Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          // firstPageList();
          getAllIndentCreated();
          toast.success("Success");
          setRoleName("");
          setSubmitDisable(false);
          setCheckedState([])
          setPOItemCheckBoxId([])
          setIsAdmin(0)
        }
        if (createRes.status === false) {
          setSubmitDisable(false);
        }
        if (createRes?.error?.message.role_name) {
          toast.error(createRes.error.message.role_name);
        } else if (createRes?.error?.message) {
          toast.error("Some Issue !");
        }
      });
  }

  // Listing record
  function firstPageList(url = `${BaseURL}/permissions?q=`) {
    setSpinner(true);
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((divisionList) => {
        if (divisionList?.status) {
          const revData = divisionList?.data.reverse();
          setFirstPage(revData);
          setTotalNo(divisionList?.data?.total);
          setLinks(divisionList?.data?.links);
          setFrom(divisionList?.data?.from);
          setTo(divisionList?.data?.to);
          setSpinner(false);
        }
      });
  }

  // CHECK BOX
  const [checkAll, setCheckAll] = useState(false);
  // const [checkedState, setCheckedState] = useState(
  //   new Array(firstPage?.length).fill(checkAll)
  // );

  // const [checkedState, setCheckedState] = useState(
  //   new Array(firstPage?.length).fill(false)
  // );

  // const initialCheckboxValue = firstPage.map((item, indexes) => ({
  //   id: item.id,
  //   name: item.name,
  //   slug: item.slug,
  //   checked: false,
  // }));

  // DYNAMIC C H E C K B O X developedbykpk
  // const initialCheckboxValue = firstPage.map((item) => item.slug);
  const [checkedState, setCheckedState] = useState([]);
  // useEffect(() => {
  //   setCheckedState(initialCheckboxValue);
  // }, []);
  // console.log("checkedState", checkedState, firstPage);


  function editBtn(id) {
    fetch(`${BaseURL}/roles/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((selectedRecord) => {
        if (selectedRecord.status) {
          // setChangingSelect(true);
          setAddMoreToggle(true);
          setSubmitAction("update");
          // setDivision(selectedRecord.data.division || "");
          setRoleName(selectedRecord?.data?.name || "");
          setIsAdmin(selectedRecord?.data?.is_admin)
          const permissionsData = selectedRecord?.data?.permissions;
          // const arrangePermissionData = permissionsData.map((item) => ({
          //   id: item.id,
          //   name: item.name,
          //   slug: item.slug,
          //   checked: false,
          // }));
          const arrangePermissionData = permissionsData.map(
            (item) => item.slug
          );
          setCheckedState(arrangePermissionData);
          const permissionIds = permissionsData.map(item=> item.id);
          setPOItemCheckBoxId(permissionIds)
          // console.log("arrangePermData", arrangePermissionData);
          // TOP SCROLLING ==========
          // const scrollToTop = () => {
          window.scrollTo({
            top: 0,
            behavior: "smooth", // You can use 'auto' instead of 'smooth' for instant scrolling
          });
          // };
          toast.success("Go to update form");

          if (selectedRecord?.data) {
            // navigate("/purchase/update-indent");
          } else {
            toast.error("Items not found !");
          }
        }
      });
    // setChangingSelect(false);
  }
  // UPDATE A RECORD
  async function updateARecord(e, id) {
    e.preventDefault();
    setUpdateDisable(true);
    const formData = { role_name: roleName, permissions: poItemCheckBoxId, is_admin: isAdmin };
    const updRes = await fetch(`${BaseURL}/roles/${id}`, {
      method: "PATCH",
      body: JSON.stringify(formData),
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      // body: JSON.stringify({name: divisionName}),
    })
      .then((res) => res.json())
      .then((upd) => {
        if (upd.status) {
          // firstPageList();
          getAllIndentCreated()
          setGetId(0);
          toast.success("Updated");
          setCheckedState([])
          setPOItemCheckBoxId([])
          setIsAdmin(0)
          setRoleName("");
          setSubmitAction("submit");
          setUpdateDisable(false);
        }
        if (upd.status === false) {
          setUpdateDisable(false);
        }
        if (upd?.error?.message.name) {
          toast.error(upd.error.message.name);
        }
      });
  }

  function cancelFun() {
    setSubmitAction("submit");
    setRoleName("");
    setCheckedState([])
    setPOItemCheckBoxId([])
    setGetId(0);
    setUpdateDisable(false);
    setSubmitDisable(false);
    setEditDisable(false);
  }

  // console.log("isAdmin", isAdmin)
  const isAdminCheckFun=()=>{
    // setCheckedState([])
    // setPOItemCheckBoxId([])

    const initialCheckboxValue = firstPage.map((item) => item.slug);
    setCheckedState(initialCheckboxValue);

    const getIds = firstPage.map((item) => item.id);
    setPOItemCheckBoxId(getIds);
  }

  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div>
          <div
            className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-4 rounded-tr-lg rounded-tl-lg ${
              darkTheme ? "border-b-slate-700" : "border-b-slate-200"
            }`}
          >
            Create Role
          </div>
          <div
            // className="grid grid-cols-1 gap-8 md:gap-1 lg:gap-4 md:grid-cols-2"
            className="flex flex-col justify-between items-center gap-2 bg-[#8CDDCD] px-2 pt-3 pb-5"
          >
            <div className="w-full px-2 md:w-[40%]">
              <form action="">
                <div className="flex gap-1 md:gap-4 items-center flex-col md:flex-row">
                  <MyInput
                    label="Role Name"
                    type="text"
                    value={roleName}
                    onChange={(e) => setRoleName(e.target.value)}
                    className="w-[260px] md:w-[300px] lg:w-[360px] block"
                    mendatory="*"
                  />

                  <div className="flex items-center gap-1">
                    <input
                      checked={isAdmin== "1" ? true : false}
                      type="checkbox"
                      onChange={(e) => {
                        e.target.checked ? setIsAdmin(1) : setIsAdmin(0);
                      }}
                      onClick={()=> isAdminCheckFun()}
                    />
                    <label>Is this role is Admin</label>
                  </div>
                </div>
              </form>
            </div>

            {isAdmin == 0 ? (
              <div className="w-full px-2 md:w-[70%]">
                <CreateRolePageForm
                  editBtn={editBtn}
                  firstPageList={firstPageList}
                  links={links}
                  firstPage={firstPage}
                  setGetId={setGetId}
                  spinner={spinner}
                  totalNo={totalNo}
                  from={from}
                  to={to}
                  editDisable={editDisable}
                  setPOItemCheckBoxId={setPOItemCheckBoxId}
                  poItemCheckBoxId={poItemCheckBoxId}
                  checkedState={checkedState}
                  setCheckedState={setCheckedState}
                  checkAll={checkAll}
                  setCheckAll={setCheckAll}
                />
              </div>
            ) : (
              <span className="text-red-600">All permissions is Allow</span>
            )}

            {submitAction === "submit" && (
              // <>
              //   {poItemCheckBoxId.length > 0 && (
              <div className="flex items-center justify-start gap-x-1">
                <Button
                  disabled={submitDisable}
                  type="submit"
                  onClick={(e) => createDivision(e)}
                >
                  {submitDisable ? "Wait.." : "Submit"}
                </Button>
                <Button type="button" onClick={() => cancelFun()}>
                  Clear
                </Button>
              </div>
              //   )}
              // </>
            )}
            {submitAction === "update" && (
              <div className="flex items-center justify-start gap-x-1">
                <Button
                  disabled={updateDisable}
                  type="submit"
                  onClick={(e) => updateARecord(e, getId)}
                >
                  {updateDisable ? "Wait.." : "Update"}
                </Button>
                <Button onClick={() => cancelFun()} type="button">
                  Cancel
                </Button>
              </div>
            )}

            {/* <hr className="border-2 border-bg-red-500 text-black" /> */}
          </div>
          <div className="w-full px-2 mt-4">
            <CreatedRoleViewPageForm
              editBtn={editBtn}
              firstPageList={getAllIndentCreated}
              links={links}
              firstPage={allIndentItem}
              setGetId={setGetId}
              spinner={spinner}
              setSpinner={setSpinner}
              totalNo={totalNo}
              from={from}
              to={to}
              addMoreToggle={addMoreToggle}
              setAddMoreToggle={setAddMoreToggle}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
